import { gerar_arquivo_de_migracao_do_censo_escolar } from "./gerar-arquivo-de-migracao-do-censo-escolar/index";

const migracao_do_censo_escolar = [
  ...gerar_arquivo_de_migracao_do_censo_escolar,
];

export { migracao_do_censo_escolar };
